// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const EyeIcon = /* @__PURE__ */ createIcon(
  'eye',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'M12 4c2.861 0 5.195 1.264 6.923 2.707 1.727 1.44 2.91 3.107 3.502 4.046.105.166.248.378.337.67l.035.13.035.216a2.2 2.2 0 0 1-.035.678c-.082.36-.252.61-.372.8-.593.939-1.776 2.605-3.502 4.046C17.195 18.736 14.861 20 12 20c-2.862 0-5.195-1.265-6.923-2.707-1.727-1.44-2.91-3.107-3.503-4.046-.12-.19-.289-.44-.371-.8a2.2 2.2 0 0 1 0-.894c.082-.36.25-.61.37-.8.593-.939 1.777-2.605 3.504-4.046C6.805 5.264 9.138 4 11.999 4m0 2c-2.244 0-4.138.988-5.642 2.243-1.506 1.257-2.56 2.734-3.093 3.577l-.11.179.03.05.08.13c.533.844 1.587 2.32 3.093 3.578C7.862 17.012 9.756 18 12 18s4.138-.988 5.642-2.243c1.506-1.257 2.56-2.734 3.093-3.577l.08-.13.028-.05-.028-.05-.08-.13c-.533-.843-1.587-2.32-3.093-3.577C16.138 6.988 14.242 6 12 6m2 6a2 2 0 1 0-4 0 2 2 0 0 0 4 0m-10.843.024-.001-.002zM16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0',
      },
    ],
  ]
);
